import { Action } from 'redux';
import { BookingAttempt } from 'types/BookingAttempt';

export const BOOKING_ATTEMPT_RESET = 'booking_attempt/reset';
export const BOOKING_ATTEMPT_ERROR = 'booking_attempt/error';

export const BOOKING_ATTEMPT_SAVE_START = 'booking_attempt/save_start';
export const BOOKING_ATTEMPT_SAVE_SUCCESS = 'booking_attempt/save_success';

interface BookingAttemptResetAction extends Action<typeof BOOKING_ATTEMPT_RESET> {}

interface BookingAttemptErrorAction extends Action<typeof BOOKING_ATTEMPT_ERROR> {}

interface BookingAttemptSaveStartAction extends Action<typeof BOOKING_ATTEMPT_SAVE_START> {}
interface BookingAttemptSaveSuccessAction extends Action<typeof BOOKING_ATTEMPT_SAVE_SUCCESS> {
    payload: {
        bookingAttempt: BookingAttempt;
    };
}

export type BookingAttemptAction =
    | BookingAttemptResetAction
    | BookingAttemptErrorAction
    | BookingAttemptSaveStartAction
    | BookingAttemptSaveSuccessAction;
